



































import { Component, Vue, PropSync, Watch } from 'vue-property-decorator'
import DatePickerComponent from '@/components/DatePickerComponent.vue'

@Component({
  components: {
    DatePickerComponent,
  },
})
export default class SelectDaysComponent extends Vue {
  @PropSync("dateType", { type: Number, default: null, required: true })
  syncDateType!: number | null

  @PropSync("startOn", { type: String, default: "", required: true })
  syncStartOn!: string

  @PropSync("endOn", { type: String, default: "", required: true })
  syncEndOn!: string

  /** カレンダーの表示制御 */
  startOnCalender = false
  endOnCalender = false

  /* カレンダー入力の制御 */
  required = false
  disabled = true
  rules = ""

  /** 期間選択パターンリスト */
  selectList = [
    {value: -3, name: "先月"},
    {value: -2, name: "先週"},
    {value: -1, name: "昨日"},
    {value: 0, name: "今日"},
    {value: 1, name: "今週"},
    {value: 2, name: "今月"},
    {value: 3, name: "過去14日"},
    {value: 9, name: "期間指定"},
  ]

  mounted() {
    this.onChangeDateType()
  }

  /**
   * 期間指定が選択されているか？
   */
  private get isFreeInput() {
    return this.syncDateType === 9
  }

  @Watch("syncDateType")
  onChangeDateType() {
    /* 現在日時を日本時間にずらす */
    const now = new Date()
    now.setTime(now.getTime() + 1000 * 60 * 60 * 9)

    const startOn = new Date(now.getTime())
    const endOn = new Date(now.getTime())
    switch (this.syncDateType) {
      case -3:
        /* 先月 */
        startOn.setUTCMonth(startOn.getUTCMonth() - 1, 1)
        endOn.setUTCDate(0)
        break
      case -2:
        /* 先週 */
        startOn.setUTCDate(startOn.getUTCDate() - startOn.getUTCDay() - 7)
        endOn.setUTCDate(endOn.getUTCDate() - endOn.getUTCDay() - 1)
        break
      case -1:
        /* 昨日 */
        startOn.setUTCDate(startOn.getUTCDate() - 1)
        endOn.setUTCDate(endOn.getUTCDate() - 1)
        break
      case 1:
        /* 今週 */
        startOn.setUTCDate(startOn.getUTCDate() - startOn.getUTCDay())
        endOn.setUTCDate(endOn.getUTCDate() - endOn.getUTCDay() + 6)
        break
      case 2:
        /* 今月 */
        startOn.setUTCDate(1)
        endOn.setUTCMonth(endOn.getUTCMonth() + 1, 0)
        break
      case 3:
        /* 過去14日 */
        startOn.setUTCDate(startOn.getUTCDate() - 13)
        break
      default:
        break
    }
    if (this.isFreeInput) {
      /* 期間指定 */
      this.required = true
      this.rules = "required"
    } else {
      /* 期間を選択値に変更 */
      this.syncStartOn = startOn.toISOString().substr(0, 10)
      this.syncEndOn = endOn.toISOString().substr(0, 10)
      this.required = false
      this.rules = ""
    }
    this.disabled = !this.required
  }
}
